import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AuthLayout from '../../templates/AuthLayout';
import LoginForm from '../../molecules/form/LoginForm';
import { Helmet } from 'react-helmet';
import Notice from '../../molecules/Notice';
import { useTranslation } from 'react-i18next';
const Login = ({ notice }) => {
    const { t } = useTranslation();
    return (_jsxs(AuthLayout, { children: [_jsx(Helmet, { children: _jsx("title", { children: t('users.sign_in_title') }) }), notice && _jsx(Notice, { ...notice }), _jsx(LoginForm, {})] }));
};
export default Login;
